// src/components/ServiceSection.js (CORREGIDO: Ahora importa ServiceSection.css)

import React from 'react';
import { FaClock, FaHourglassHalf, FaLightbulb, FaArrowRight } from 'react-icons/fa'; 
import { useNavigate } from 'react-router-dom'; 
// 🛑 LÍNEA CORREGIDA: Debe importar ServiceSection.css, no TeamPage.css
import './ServiceSection.css'; 

const ServiceSection = () => {
    const navigate = useNavigate(); 
    
    const services = [
        {
            time: 'Consulta Express',
            icon: FaClock,
            description: '30 Minutos. Perfecta para preguntas rápidas o aclarar dudas específicas. Recibe orientación concisa y efectiva.',
            price: '**$100.00 USD**',
            linkPage: '/consultas/30-minutos' 
        },
        {
            time: 'Análisis Profundo',
            icon: FaHourglassHalf,
            description: '1 HORA. Ideal para un análisis más profundo. Discute tus inquietudes en detalle y recibe asesoría personalizada.',
            price: '**$190.00 USD**',
            linkPage: '/consultas/1-hora' 
        },
        {
            time: 'Estrategia Especial',
            icon: FaLightbulb,
            description: 'Diseñada para casos exhaustivos y complejos. Desarrolla un plan adaptado a tus necesidades y objetivos específicos.',
            price: '**Precio a Convenir**',
            linkPage: '/consultas/especial' 
        },
    ];

    return (
        <section className="service-section-container">
            <h2 style={{color: '#3b5998'}}>Consulta Online con Nuestros Expertos</h2>
            <p style={{marginBottom: '50px', fontSize: '1.1em', color: '#555'}}>Ofrecemos diferentes tipos de consultas para adaptarnos a tus necesidades.</p>
            
            <div className="service-cards-grid">
                {services.map((service, index) => (
                    <div className="service-card" key={index}>
                        <service.icon className="service-icon" /> 
                        <h3>{service.time}</h3>
                        <p>{service.description}</p>
                        <p className="service-price">Precio Habitual: {service.price}</p>
                        
                        <button 
                            className="cta-button small"
                            onClick={() => navigate(service.linkPage)}
                        >
                            Agendar Consulta <FaArrowRight style={{marginLeft: '8px'}}/>
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ServiceSection;